export const getZendeskAPIValue = (fullURL: string): string => {
  if (fullURL) {
    const regex = /(articles|categories|sections)\/\d+/

    const match = regex.exec(fullURL)

    if (match) {
      return match[0] // Output articles/123
    }
    return ''
  }

  return ''
}
